import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Attributes } from '../models/attributes';

@Injectable({
  providedIn: 'root'
})
export class AttributesService {
  private baseUrl: string = `${environment['api_backend']}/api`

  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(error);
  }

  constructor(private http: HttpClient) { }

  createBrands(brand: Attributes) {
    console.log('INGRESANDOO AL CREAR MARCA')
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-brands`, brand, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createCategories(category: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-categories`, category, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createShapes(shape: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-shapes`, shape, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createPackages(packages: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-packages`, packages, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createLines(line: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-lines`, line, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createFlavors(flavor: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-flavors`, flavor, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createMultipackages(multipackage: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-multipackages`, multipackage, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createSizes(size: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-sizes`, size, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createCompanies(company: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-companies`, company, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  createEans(ean: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${this.baseUrl}/library-ean`, ean, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateBrands(brand: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-brands/${id}`, brand, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateCategories(category: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-categories/${id}`, category, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateShapes(shape: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-shapes/${id}`, shape, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updatePackages(packages: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-packages/${id}`, packages, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateLines(line: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-lines/${id}`, line, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateFlavors(flavor: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-flavors/${id}`, flavor, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateMultipackages(multipackage: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-multipackages/${id}`, multipackage, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateSizes(size: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-sizes/${id}`, size, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateCompanies(company: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-companies/${id}`, company, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  updateEans(ean: Partial<Attributes>, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.patch<any>(`${this.baseUrl}/library-ean/${id}`, ean, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteBrand(ids: number[]): Observable<any>  {
  return this.http.request('delete', `${this.baseUrl}/library-brands`, {
    body: { ids }
  });
}


  deleteCategory(ids: number[]) : Observable<any>  {
    return this.http.request('delete', `${this.baseUrl}/library-categories`, {
    body: { ids }
  });
  }

  deleteShape(ids: number[]): Observable<any>{
    return this.http.request('delete', `${this.baseUrl}/library-shapes`, {
    body: { ids }
  });
  }

  deletePackage(ids: number[]): Observable<any>{
     return this.http.request('delete', `${this.baseUrl}/library-packages`, {
    body: { ids }
  });
  }

  deleteLine(ids: number[]): Observable<any> {
     return this.http.request('delete', `${this.baseUrl}/library-lines`, {
    body: { ids }
  });
  }

  deleteFlavor(ids: number[]) : Observable<any>{
    return this.http.request('delete', `${this.baseUrl}/library-flavors`, {
    body: { ids }
  });
  }

  deleteMultipackage(ids: number[]): Observable<any> {
    return this.http.request('delete', `${this.baseUrl}/library-multipackages`, {
    body: { ids }
  });
  }

  deleteSize(ids: number[]): Observable<any> {
    return this.http.request('delete', `${this.baseUrl}/library-sizes`, {
    body: { ids }
  });
  }

  deleteCompany(ids: number[]): Observable<any> {
     return this.http.request('delete', `${this.baseUrl}/library-companies`, {
    body: { ids }
  });
  }

  deleteEan(ids: number[]) : Observable<any>{
     return this.http.request('delete', `${this.baseUrl}/library-ean`, {
    body: { ids }
  });
  }


  createAttr(d: any, data: Attributes): Observable<any[]> {
    console.log('Recibido en createData:', d, 'tipo:', d.type, 'typeof:', typeof d.type);
    console.log('DATOS PARA CREACION', data)
    switch (d.type) {
      case 'brand':
        return this.createBrands(data);
      case 'category':
        return this.createCategories(data);
      case 'shape':
        return this.createShapes(data);
      case 'package':
        return this.createPackages(data);
      case 'line':
        return this.createLines(data);
      case 'flavor':
        return this.createFlavors(data);
      case 'multipackage':
        return this.createMultipackages(data);
      case 'size':
        return this.createSizes(data);
      case 'company':
        return this.createCompanies(data);
      case 'ean':
        return this.createEans(data);
      default:
        console.warn(`No existe una función para el tipo: ${d.type}`);
        return of([]);
    }
  }

  updateAttr(d: any, data: Partial<Attributes>, id: number): Observable<any[]> {
    console.log('Recibido en updateData:', d, 'tipo:', d.type, 'typeof:', typeof d.type);
    switch (d.type) {
      case 'brand':
        return this.updateBrands(data, id);
      case 'category':
        return this.updateCategories(data, id);
      case 'shape':
        return this.updateShapes(data, id);
      case 'package':
        return this.updatePackages(data, id);
      case 'line':
        return this.updateLines(data, id);
      case 'flavor':
        return this.updateFlavors(data, id);
      case 'multipackage':
        return this.updateMultipackages(data, id);
      case 'size':
        return this.updateSizes(data, id);
      case 'company':
        return this.updateCompanies(data, id);
      case 'ean':
        return this.updateEans(data, id);
      default:
        console.warn(`No existe una función para el tipo: ${d.type}`);
        return of([]);
    }
  }

    deleteAttr(d: any, ids: number[]): Observable<any[]> {
    console.log('Recibido en createData:', d, 'tipo:', d.type, 'typeof:', typeof d.type);

    switch (d.type) {
      case 'brand':
        return this.deleteBrand(ids);
      case 'category':
        return this.deleteCategory(ids);
      case 'shape':
        return this.deleteShape(ids);
      case 'package':
        return this.deletePackage(ids);
      case 'line':
        return this.deleteLine(ids);
      case 'flavor':
        return this.deleteFlavor(ids);
      case 'multipackage':
        return this.deleteMultipackage(ids);
      case 'size':
        return this.deleteSize(ids);
      case 'company':
        return this.deleteCompany(ids);
      case 'ean':
        return this.deleteEan(ids);
      default:
        console.warn(`No existe una función para el tipo: ${d.type}`);
        return of([]);
    }
  }
}
